<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fields"
          :status="status"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actions"
          :optionsButton="optionsButton"
          :items="listaAplicacoes"
        >
        </fccTable>
      </div>
    </div>
    <fccModal
      centered
      idModal="versaoAppModal"
      size="lg"
      titleModal="Versionamento de Sistema"
      escondeFooter
      travaEsc
      travaBack
      @close="aplicacoes = {}"
    >
      <FccVersionamento :app-id="aplicacoes.appid" v-if="aplicacoes.appid != null" />
    </fccModal>
    <fccModal
      centered
      idModal="editApp"
      size="lg"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
      @close="aplicacoes = {}"
    >
      <form
        v-if="aplicacoes != null"
        @submit.prevent="aplicacoes.appid === 0 ? adicionandoApp() : editandoApp()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <div class="col-sm-12">
            <input v-model="aplicacoes.appid" type="hidden" />
            <input v-model="aplicacoes.appcodigo" type="hidden" v-if="aplicacoes.appid !== 0" />
            <fccInput extraClasses="inputLabel" v-model="aplicacoes.appnome" required
              >Nome</fccInput
            >
          </div>
        </div>
        <div class="row innerPage" v-if="aplicacoes.appid === 0">
          <div class="col-sm-6">
            <fccInput
              extraClasses="inputLabel"
              type="number"
              v-model="aplicacoes.appcodigo"
              required
              >Código</fccInput
            >
          </div>
          <div class="col-sm-6">
            <fccInput extraClasses="inputLabel" type="text" v-model="public_path" required
              >Public Path</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" type="email" v-model="aplicacoes.appemail" required
              >Email</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" type="url" v-model="aplicacoes.appurl" required
              >Url</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-2">
            <label>Ativo</label><br />
            <toggle-button v-model="aplicacoes.appativo" />
          </div>

          <div class="col-sm-2">
            <label>Acesso externo</label><br />
            <toggle-button v-model="aplicacoes.appacessoexterno" />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
    <fccModal
      centered
      idModal="editparam"
      size="lg"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="editandoParametros" autocomplete="off">
        <div class="row innerPage">
          <div class="col-sm-6">
            <input v-model="parametros.appid" type="hidden" />
            <fccInput extraClasses="inputLabel" v-model="parametros.appparampublicpath" required
              >Public Path</fccInput
            >
          </div>
          <div class="col-sm-6">
            <fccInput
              extraClasses="inputLabel"
              type="number"
              v-model="parametros.appparamversao"
              required
              >Versão Sistema</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <fccInput
              extraClasses="inputLabel"
              type="number"
              v-model="parametros.appparamvalidadetoken"
              required
              >Validade Token (Horas)</fccInput
            >
          </div>
          <div class="col-sm-6">
            <fccInput
              extraClasses="inputLabel"
              type="number"
              v-model="parametros.appparamcomplexidadesenha"
              required
              >Complexidade Senha (Nível)</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <fccInput
              extraClasses="inputLabel"
              type="number"
              v-model="parametros.appparamtemponovotoken"
              required
              >Tempo para Renovação Token (Horas)</fccInput
            >
          </div>
          <div class="col-sm-6">
            <fccInput
              extraClasses="inputLabel"
              type="number"
              v-model="parametros.appparamtemponotificacoes"
              required
              >Tempo para Notificações (Minutos)</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <fccInput
              extraClasses="inputLabel"
              type="number"
              v-model="parametros.appparamtentativasloginbloqueio"
              required
              >Tentativas para Bloqueio de Login</fccInput
            >
          </div>
          <div class="col-sm-6">
            <fccInput
              extraClasses="inputLabel"
              type="number"
              v-model="parametros.appparamtempoesperabloqueio"
              required
              >Tempo de Espera para Desbloqueio (Minutos)</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <label>Permite Várias Sessões</label><br />
            <toggle-button v-model="parametros.appparampermitevariassecoes" />
          </div>
          <div class="col-sm-6">
            <label>Usuário Interno</label><br />
            <toggle-button v-model="parametros.appparamvalidafluxo" />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import FccVersionamento from './fccVersionamento.vue'

export default {
  components: { FccVersionamento },
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Aplicações',
      titleModal: '',
      titlePDF: 'Aplicações',
      listaAplicacoes: [],
      baseUrlSeguranca: '',
      aplicacoes: {},
      public_path: '',
      parametros: {},
      itemPorPage: '100',
      fields: [
        { key: 'appcodigo', label: 'Código Aplicação', sortable: true },
        { key: 'appnome', label: 'Nome', sortable: true },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          tdClass: 'no-print',
          thClass: 'no-print'
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print' }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editApp',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'listaParam',
          icon: 'cog',
          tooltip: 'Parâmetros',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'listaObjeto',
          icon: 'bars',
          tooltip: 'Menu',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'permissao',
          icon: 'lock',
          tooltip: 'Permissões',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'versoesApp',
          icon: 'info',
          tooltip: 'Versões',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteApp',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      optionsButton: [
        {
          funcaoButton: 'addField',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        { funcaoButton: 'ordenaMenu', tooltip: 'Ordenar', icon: 'sort-amount-up' },
        { funcaoButton: 'objetosAcao', tooltip: 'Objetos Ação', icon: 'lock' }
      ],
      status: [
        {
          funcaoButton: 'changeStatus',
          tooltip: 'Alterar Status',
          campoStatus: 'appativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ]
    }
  },
  methods: {
    ordenaMenu: function () {
      this.$router.push({ path: '/seguranca/aplicacoes/ordena/' })
    },
    permissao: function (action, item) {
      this.$router.push({ path: '/seguranca/permissao/acesso/' + item.appid })
    },
    listandoAplicacoes: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(this.baseUrlSeguranca + 'App/listartodosapp', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listaAplicacoes = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listaParam: function (action, item) {
      axios
        .get(
          this.baseUrlSeguranca + 'App/listarappparam/' + item.appid,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.parametros = response.data
          this.titleModal = 'Editar Parâmetros'
          this.$root.$emit('bv::show::modal', 'editparam')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    objetosAcao: function () {
      this.$router.push({ path: '/seguranca/objetos' })
    },
    listaObjeto: function (action, item) {
      this.$router.push({ path: '/seguranca/aplicacoes/objetos/' + item.appid })
    },
    addField: function () {
      this.titleModal = 'Adicionar Aplicação'
      this.aplicacoes = {}
      this.aplicacoes.appid = 0
      this.$root.$emit('bv::show::modal', 'editApp')
    },
    changeStatus: function (action, item) {
      this.aplicacoes = item
      this.editandoApp()
    },
    editApp: function (action, item) {
      this.titleModal = 'Editar Aplicação'
      this.aplicacoes = item
      this.$root.$emit('bv::show::modal', 'editApp')
    },
    editandoParametros: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrlSeguranca + 'App/alterarappparam',
          this.parametros,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.carregaTexto()
          this.parametros = {}
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editparam')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    adicionandoApp: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlSeguranca + 'App/incluirapp',
          this.aplicacoes,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.adicionandoParam(response.data)
          this.aplicacoes = {}
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editApp')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    adicionandoParam: function (item) {
      var param = {
        appativo: 'false',
        appid: item,
        appparamcomplexidadesenha: 2,
        appparamdataalteracao: null,
        appparamdatacriacao: null,
        appparamdataexclusao: null,
        appparamid: 0,
        appparampermitevariassecoes: true,
        appparampublicpath: this.public_path,
        appparamtempoesperabloqueio: 1,
        appparamtemponotificacoes: 1,
        appparamtemponovotoken: 0,
        appparamtentativasloginbloqueio: 3,
        appparamvalidafluxo: true,
        appparamvalidadetoken: 8,
        appparamversao: '1.0'
      }
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlSeguranca + 'App/incluirappparam',
          param,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoAplicacoes()
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editApp')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editandoApp: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrlSeguranca + 'App/alterarapp',
          this.aplicacoes,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoAplicacoes()
          this.carregaTexto()
          this.aplicacoes = {}
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editApp')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    versoesApp(_, item) {
      this.aplicacoes = item
      this.$root.$emit('bv::show::modal', 'versaoAppModal')
    },
    deleteApp: function (action, item) {
      this.callConfirm(this.mensagemExcluir, item.appnome).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSeguranca + 'App/excluirapp?appID=' + item.appid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoAplicacoes()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    }
  },
  mounted: function () {
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranca
    this.listandoAplicacoes()
  }
}
</script>
